import React from "react";
import ReactSlider from "react-slider";
import "bootstrap/dist/css/bootstrap.min.css";

const CommonRangeSlider = ({
  min,
  max,
  values, // controlled values from parent
  onChange,
  dollarSign = false,
}) => {
  const handleChange = (newValues) => {
    if (onChange) onChange(newValues);
  };

  return (
    <>
      {/* Price Labels */}
      <div className="d-flex justify-content-between">
        <span className="plabel">
          {dollarSign ? "$" : ""}
          {values[0]}
        </span>
        <span className="plabel">
          {dollarSign ? "$" : ""}
          {values[1]}
        </span>
      </div>

      {/* Dual Range Slider */}
      <ReactSlider
        className="custom-slider"
        trackClassName="custom-slider-track"
        thumbClassName="custom-slider-thumb"
        min={min}
        max={max}
        value={values}
        onChange={handleChange}
        pearling
        minDistance={5}
      />
    </>
  );
};

export default CommonRangeSlider;
